import React, { useState, useEffect } from 'react';

const ActionButtons = ({ onSave, onRunScheduler, isSchedulerRunning }) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    let timeoutId;
    if (isSchedulerRunning) {
      // Show loader after 2 seconds
      timeoutId = setTimeout(() => setShowLoader(true), 2000);
    } else {
      setShowLoader(false);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isSchedulerRunning]);

  return (
    <div className="action-buttons">
      <div className="run-scheduler-container-left">
        <button onClick={onSave} className="save-btn" disabled={isSchedulerRunning}>Save</button>
      </div>
      <div className="run-scheduler-container-right">
        <button onClick={onRunScheduler} className="run-scheduler-btn" disabled={isSchedulerRunning}>
          {isSchedulerRunning ? (showLoader ? "Scheduler is generating appointments. Please Wait" : "Running...") : "Run-Scheduler"}
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;